import { Component, OnInit} from '@angular/core';
import {ColDef, ColGroupDef, GridOptions} from "ag-grid-enterprise";
import { BehaviorSubject, takeWhile } from 'rxjs';
import { FrtSyncadaInvoicesService } from 'src/app/services/frt-syncada-invoices/frt-syncada-invoices.service';
import { User } from 'src/app/services/user/user';
import { UserService } from 'src/app/services/user/user.service';
import { UserPreference } from '../../user-preferences/user-preference';
import { PrefItem } from '../../user-preferences/pref-item';
import AppConstants,* as Constants  from 'src/app/shared/common-components/AppConstants';
import  {agency_auditor_role, BusinessType} from 'src/app/shared/common-components/AppConstants';
import { Router } from '@angular/router';
import _ from 'lodash';
import moment from 'moment';
import { FRTSyncadaIFFStagingEntity } from 'src/app/shared/common-components/common-structure';
import { DatePipe } from '@angular/common';

@Component({
    selector: "frt-syncada-shipment-invoices",
    templateUrl: "./frt-syncada-shipment-invoices.component.html",
    styleUrls: ["./frt-syncada-shipment-invoices.component.css"],
    standalone: false
})
export class FrtSyncadaShipmentInvoicesComponent implements OnInit {
  title = "FRT Syncada Reconciliation Report";
  gridOptions: GridOptions = this.initializeGridOptions();
  columnDefs: (ColDef | ColGroupDef)[];
  private gridApi;
  totalAmount;
  overlayNoRowsTemplate: string = null;
  rowData: FRTSyncadaIFFStagingEntity[];
  showGrid: Boolean = false;
  currentUser: User;
  private observer$ = new BehaviorSubject(true);
  userPref: UserPreference;
  userPrefList: PrefItem[];
  agency_admin = Constants.agency_admin_role;
  agency_user = Constants.agency_user;
  orgId: number;
  carrierUser: boolean;
  carrierId: number;
  constructor(
    private frtSyncadaInvoicesService: FrtSyncadaInvoicesService,
    private userService: UserService,
    private router: Router,
    private datePipe: DatePipe
  ) {
    this.overlayNoRowsTemplate =
      '<span style="margin-top: 90px;">No rows to display.</span>';
  }

  ngOnInit() {
    this.getCurrentUser();
    this.getFrtSyncadaShipmentInvoices();
    this.updateColumnDefs();
  }


  getFrtSyncadaShipmentInvoices() {
    this.frtSyncadaInvoicesService.getAllFrtSycadaShipmentInvoices().subscribe({
      next: (data: any) => {
        this.rowData = data;
        this.convertDateTimeToDate();
        this.showGrid = true;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  convertDateTimeToDate(){
    this.rowData = this.rowData.map(item => {
      item.moveDate = AppConstants.isNotNullCondition(item.moveDate) ? this.datePipe.transform(item.moveDate, 'MM/dd/yyyy') : "";
      item.invoicePaidDate = AppConstants.isNotNullCondition(item.invoicePaidDate) ? this.datePipe.transform(item.invoicePaidDate, 'MM/dd/yyyy') : "";
      item.sentDate = AppConstants.isNotNullCondition(item.sentDate) ? this.datePipe.transform(item.sentDate, 'MM/dd/yyyy') : "";
      return item;
    });
  }

  private 
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
      sortable: true,
      resizable: true,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: false
      }
    },
    pagination: true,
    paginationPageSize: 20,
    cacheBlockSize: 25,
    headerHeight: 50,
    domLayout: 'autoHeight',
    suppressDragLeaveHidesColumns: true,

    overlayLoadingTemplate:
      '<span class="ag-overlay-loading-center">Select the Reporting Year/Quarter to load report.</span>',
    overlayNoRowsTemplate:
      '<span>No results found. Please adjust your filters.</span>'
    };
  }

  updateColumnDefs() {
    this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
  }

  getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        headerName: 'BOL Number',
        field: 'bolNumber',
        width: 100,
        filter: 'agTextColumnFilter',
        cellRenderer: params => {
          if ((null != params.data.bolNumber || params.data.bolNumber) && !this.checkUserRole(agency_auditor_role)) {
            return '<a tabindex="0">' + params.data.bolNumber + '</a>';
          }
          return params.data.bolNumber;
        },
        onCellClicked: event => !this.checkUserRole(agency_auditor_role) ? this.onShipmentIdClicked(event.data) : null
      },
      {
        headerName: "Shipment ID",
        field: "bookShipmentId",
        filter: "agNumberColumnFilter",
        width: 100,
        cellRenderer: (params) => {
          if (null != params.data.bolNumber || params.data.bolNumber || this.checkUserRole(agency_auditor_role)) {
            return params.data.bookShipmentId;
          }
          return '<a tabindex="0">' + params.data.bookShipmentId + "</a>";
        },
        onCellClicked: (event) =>
          !this.checkUserRole(agency_auditor_role)
            ? this.onShipmentIdClicked(event.data)
            : null,
      },
      
      {
        headerName: "SCAC",
        field: "scac",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "TSP Name",
        field: "carrierName",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Bill To Name",
        field: "billToName",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Shipper Name",
        field: "shipperName",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Move Date",
        field: "moveDate",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Date Sent to Syncada",
        field: "sentDate",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Invoice Paid Amount",
        field: "invoicePaidAmount",
        valueFormatter: params => this.currencyandPercentageFormatter(params.data.invoicePaidAmount, '$'),
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Invoice Paid Date",
        field: "invoicePaidDate",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Payment Initiated Date",
        field: "paymentInitiatedDate",
        cellRenderer: (params: any) => {
          if(params.data.paymentInitiatedDate === null || params.data.paymentInitiatedDate.length === 0) return "Not Yet Initiated"
          else return  this.dateFormater(params.data.paymentInitiatedDate);
        },
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Fuel SC",
        field: "fuelSC",
        valueFormatter: params => this.currencyandPercentageFormatter(params.data.fuelSC, '$'),
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "TMSS Total Cost",
        field: "totalCost",
        valueFormatter: params => this.currencyandPercentageFormatter(params.data.totalCost, '$'),
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Billable AF Amount",
        field: "billableIFFAmount",
        valueFormatter: params => this.currencyandPercentageFormatter(params.data.billableIFFAmount, '$'),
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "AF Amount",
        field: "iffAmount",
        valueFormatter: params => this.currencyandPercentageFormatter(params.data.iffAmount, '$'),
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "AF Payment Status",
        field: "iffFinStat",
        filter: "agTextColumnFilter",
        sortable: true,
      },

      {
        headerName: "AF Status Date",
        field: "iffStatusDate",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "AF %",
        field: "iffPercentage",
        valueFormatter: params => this.currencyandPercentageFormatter(params.data.iffPercentage, '%'),
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Mode",
        field: "mode",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Agency Name",
        field: "agencyName",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Bureau Name",
        field: "bureauName",
        filter: "agTextColumnFilter",
        sortable: true,
      }

    ];
  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption("headerHeight", 30);
  }

  checkUserRole(roles: any) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, (x) => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

  getCurrentUser() {
    this.userService
      .getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe((currentUser) => {
        this.currentUser = currentUser;
        // this.getUserPrefs();
        if (AppConstants.isNotNullCondition(this.currentUser)) {
          if (
            this.currentUser.roles[0].name === this.agency_admin ||
            this.currentUser.roles[0].name === this.agency_user
          ) {
            this.orgId = this.currentUser.organizationId;
          } else {
            this.orgId = -1;
          }
        } else {
          this.orgId = -1;
        }
        if (this.currentUser.carrierId !== null) {
          this.carrierUser = true;
          this.carrierId = this.currentUser.carrierId;
        } else {
          this.carrierUser = false;
          this.carrierId = -1;
        }
        // this.getShipmentReviewList('FRT', 'All');
        // this.recent = true;
      });
  }

  onShipmentIdClicked(shipmentReviewListSelectedItem: any) {
    this.router.navigate(["/", "shipmentcontrolreview"], {
      queryParams: {
        bookshipmentid: shipmentReviewListSelectedItem.bookShipmentId,
        shipmentType: BusinessType.FRT,
      },
    });
  }

  currencyandPercentageFormatter(currency: number, sign: string) {
    if (sign === '%') {
      return (null === currency) ? "" : currency + sign ;
    } else {
       return (null === currency) ? "" : sign + currency ;
    }
  }

  dateFormater(dateFormater: any){
    if (AppConstants.isNotNullCondition(dateFormater)) {
      return moment(dateFormater).format("MM/DD/YYYY");
    }
    return "";
  }
}
